const formatNumberWithCommas = (number) => {
  if (number === null || typeof number === "undefined" || isNaN(+number)) {
    return number;
  }

  const num = Number(number);

  // Check if the number has decimal places
  const hasDecimals = num % 1 !== 0;

  return num.toLocaleString("en-US", {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  });
};

export default formatNumberWithCommas;
